exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookSidebar{font-size:.8em}.bookSidebar .bookContainer{cursor:pointer;padding:10px;padding-top:15px;padding-bottom:0;margin-right:20px;border:1px solid transparent}.bookSidebar .bookContainer:hover{opacity:.7}.bookSidebar .bookContainer.selectedBook{border:1px solid #ddd;border-radius:5px}.bookSidebar .bookContainer .bookCover{margin-bottom:20px}.bookSidebar .bookContainer .bookCover .bookDetails{padding-left:5px;text-align:center;width:115px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/book_sidebar.scss
// module id = 1370
// module chunks = 0